<template>
  <div class="full-calendar-header">
    <!-- <div class="header-left">
      <slot name="header-left">
        
      </slot>
    </div> -->
    <div class="header-center">
			<span class="prev-month flex-center" @click.stop="goPrev" :class="{'noActive':btnShow}">
        <i class="el-icon-arrow-left"></i>
			</span>
      <span class="title">{{title}}</span>
			 <span class="next-month flex-center" @click.stop="goNext">
         <i class="el-icon-arrow-right"></i>
			 </span>
    </div>
    <!-- <div class="header-right">
      <slot name="header-right">
      </slot>
    </div> -->
  </div>
</template>
<script type="text/babel">
  import dateFunc from './dateFunc'
  import moment from 'moment';

  export default {
    props : {
      currentMonth : {},
      titleFormat  : {},
      firstDay     : {},
      monthNames   : {},
      locale       : {},
      btnShow:{type:Boolean,default:true}
    },
    data () {
      return {
      }
    },
    computed: {
      //年月的标题
      title () {
        if (!this.currentMonth) return;        
        let  date = new Date(this.currentMonth);
        let teamTime = date.getFullYear() + ' 年' + ' '+(date.getMonth() + 1) + ' 月'
        return teamTime
      }
    },
    methods : {
      goPrev () {
        var newMonth = moment(this.currentMonth).subtract(1, 'months').startOf('month');
        this.$emit('change', newMonth);
      },
      goNext () {
        var newMonth = moment(this.currentMonth).add(1, 'months').startOf('month');
        this.$emit('change', newMonth);
      }
    }
  }
</script>
<style lang="less">
.full-calendar-header{
  // display: flex;
  // align-items: center;
  // .header-left,.header-right{
  //   flex:1;
  // }
  .header-center{
    display: flex;
    justify-content:space-between;
    align-items: center;
    text-align:center;
    .title{
      margin: 0 60px;
			color: #237dc8;
    }
    .prev-month,.next-month{
      cursor: pointer;
      color: white;
      background: #227dc7;
      width: 26px;
      height: 26px;
    }
		.noActive{
      background: #b2b2b2;
    }
  }
}
</style>
